import React from "react";
import { Link } from "react-router-dom";
import { useCurrentUser } from "../context/UserContext";

export default function UserNavbar(props) {
  const { currentUser } = useCurrentUser();

  const iconBaseStyle = {
    color: "#4b5563",
    transition: "color 0.15s ease",
  };

  const handleIconHover = (e) => {
    e.currentTarget.style.color = "#1A56DB";
  };

  const handleIconLeave = (e) => {
    e.currentTarget.style.color = "#4b5563";
  };

  // Derive display name + avatar initial once, outside JSX
  const rawName = currentUser?.name || localStorage.getItem("name") || "";
  const displayName =
    rawName && !rawName.includes("@")
      ? rawName
      : currentUser?.email
        ? currentUser.email.split("@")[0]
        : "User";
  const avatarChar = displayName.charAt(0).toUpperCase();

  return (
    <>
      <nav className="main-header navbar navbar-expand navbar-white navbar-light">
        <ul className="navbar-nav">
          <li className="nav-item">
            <button
              type="button"
              onClick={() => {
                console.log("hamburger clicked, current:", props.hamburger);
                // Safe toggle — works whether parent passes a state setter
                // or a pre-bound handler
                if (typeof props.sethamburger === "function") {
                  props.sethamburger((prev) => !prev);
                }
              }}
              style={{
                cursor: "pointer",
                background: "none",
                border: "none",
                padding: "8px",
              }}
            >
              <i className="fa fa-bars"></i>
            </button>
          </li>
          <li className="nav-item d-none d-sm-inline-block">
            <Link to="/landingpage" className="nav-link">
              Home
            </Link>
          </li>
          <li className="nav-item d-none d-sm-inline-block">
            <Link to="/contact_us" className="nav-link">
              Contact
            </Link>
          </li>
        </ul>
        <ul className="navbar-nav ml-auto">
          <li className="nav-item">
            <i
              onClick={props.handelShow}
              style={{ cursor: "pointer" }}
              className="fa fa-search"
            ></i>
            <div
              className={`${props.isSearchShow
                  ? "navbar-search-block navbar-search-open"
                  : "navbar-search-block"
                }`}
            >
              <form className="form-inline">
                <div className="input-group input-group-sm">
                  <input
                    className="form-control form-control-navbar"
                    type="search"
                    placeholder="Search"
                    aria-label="Search"
                  />
                  <div className="input-group-append">
                    <button className="btn btn-navbar" type="submit">
                      <i className="fa fa-search"></i>
                    </button>
                    <button
                      className="btn btn-navbar"
                      type="button"
                      data-widget="navbar-search"
                    >
                      <i onClick={props.handelShow} className="fa fa-times"></i>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </li>

          {/* <!-- Messages Dropdown Menu --> */}
          <li className="nav-item dropdown">
            <a
              className="nav-link"
              data-toggle="dropdown"
              href="/"
              style={iconBaseStyle}
              onMouseEnter={handleIconHover}
              onMouseLeave={handleIconLeave}
            >
              <i className="fa fa-comments"></i>
              <span className="badge badge-danger navbar-badge">3</span>
            </a>
            <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
              <a href="/" className="dropdown-item">
                <div className="media">
                  <img
                    src={props.dummy1}
                    alt="User Avatar"
                    className="img-size-50 mr-3 img-circle"
                  />
                  <div className="media-body">
                    <h3 className="dropdown-item-title">
                      Brad Diesel
                      <span className="float-right text-sm text-danger">
                        <i className="fa fa-star"></i>
                      </span>
                    </h3>
                    <p className="text-sm">Call me whenever you can...</p>
                    <p className="text-sm text-muted">
                      <i className="fa fa-clock-o mr-1"></i> 4 Hours Ago
                    </p>
                  </div>
                </div>
              </a>
              <div className="dropdown-divider"></div>
              <a href="/" className="dropdown-item">
                <div className="media">
                  <img
                    src={props.dummy2}
                    alt="User Avatar"
                    className="img-size-50 img-circle mr-3"
                  />
                  <div className="media-body">
                    <h3 className="dropdown-item-title">
                      John Pierce
                      <span className="float-right text-sm text-muted">
                        <i className="fa fa-star"></i>
                      </span>
                    </h3>
                    <p className="text-sm">I got your message bro</p>
                    <p className="text-sm text-muted">
                      <i className="fa fa-clock-o mr-1"></i> 4 Hours Ago
                    </p>
                  </div>
                </div>
              </a>
              <div className="dropdown-divider"></div>
              <a href="/" className="dropdown-item">
                <div className="media">
                  <img
                    src={props.dummy3}
                    alt="User Avatar"
                    className="img-size-50 img-circle mr-3"
                  />
                  <div className="media-body">
                    <h3 className="dropdown-item-title">
                      Nora Silvester
                      <span className="float-right text-sm text-warning">
                        <i className="fa fa-star"></i>
                      </span>
                    </h3>
                    <p className="text-sm">The subject goes here</p>
                    <p className="text-sm text-muted">
                      <i className="fa fa-clock-o mr-1"></i> 4 Hours Ago
                    </p>
                  </div>
                </div>
              </a>
              <div className="dropdown-divider"></div>
              <a href="/" className="dropdown-item dropdown-footer">
                See All Messages
              </a>
            </div>
          </li>

          {/* <!-- Notifications Dropdown Menu --> */}
          <li className="nav-item dropdown">
            <a
              className="nav-link"
              data-toggle="dropdown"
              href="/"
              style={iconBaseStyle}
              onMouseEnter={handleIconHover}
              onMouseLeave={handleIconLeave}
            >
              <i className="fa fa-bell"></i>
              <span className="badge badge-warning navbar-badge">15</span>
            </a>
            <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
              <span className="dropdown-header">15 Notifications</span>
              <div className="dropdown-divider"></div>
              <a href="/" className="dropdown-item">
                <i className="fa fa-envelope mr-2"></i> 4 new messages
                <span className="float-right text-muted text-sm">3 mins</span>
              </a>
              <div className="dropdown-divider"></div>
              <a href="/" className="dropdown-item">
                <i className="fa fa-users mr-2"></i> 8 friend requests
                <span className="float-right text-muted text-sm">12 hours</span>
              </a>
              <div className="dropdown-divider"></div>
              <a href="/" className="dropdown-item">
                <i className="fa fa-file mr-2"></i> 3 new reports
                <span className="float-right text-muted text-sm">2 days</span>
              </a>
              <div className="dropdown-divider"></div>
              <a href="/" className="dropdown-item dropdown-footer">
                See All Notifications
              </a>
            </div>
          </li>

          {props.fullScreen ? (
            <li
              onClick={props.handleScreenEnter}
              className="nav-item"
              style={{ cursor: "pointer" }}
            >
              <i className="fa fa-arrows-alt"></i>
            </li>
          ) : (
            <li
              onClick={props.handleScreenExit}
              className="nav-item"
              style={{ cursor: "pointer" }}
            >
              <i className="fa fa-compress"></i>
            </li>
          )}

          <li className="nav-item ml-3 d-flex align-items-center">
            {currentUser ? (
              <div
                className="nav-link d-flex align-items-center"
                style={{ cursor: "default" }}
              >
                <div
                  style={{
                    width: 32,
                    height: 32,
                    borderRadius: "50%",
                    backgroundColor: "#1A56DB",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: 600,
                    fontSize: 14,
                    marginRight: 8,
                  }}
                >
                  {avatarChar}
                </div>
                <span
                  className="d-none d-md-inline text-dark mr-1"
                  style={{
                    fontFamily: "'Inter', 'Segoe UI', system-ui, sans-serif",
                    fontWeight: 500,
                    fontSize: 14,
                  }}
                >
                  {displayName}
                </span>
              </div>
            ) : (
              <Link to="/login" className="nav-link">
                Login
              </Link>
            )}
          </li>
        </ul>
      </nav>
    </>
  );
}